export default __webpack_public_path__ + "static/media/mark_zuckerberg.132683e9.jpg";